/** Opens an announcement CTA: an in-app path routes inside the SPA, an
 * http(s) link opens in a new tab. Anything else (the backend already
 * rejects it) is ignored rather than navigated to. */
export function openAnnouncementLink(url: string, navigate: (to: string) => void) {
  if (url.startsWith("/") && !url.startsWith("//")) {
    navigate(url);
  } else if (/^https?:\/\//i.test(url)) {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
